/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationModel {
    getFixupPrototypeFunction() { return ResourceRecommendationModel.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationModel>): ResourceRecommendationModel {
        let obj = Object.assign(new ResourceRecommendationModel(), model);
        ResourceRecommendationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationModel>): ResourceRecommendationModel {
        if (!model) return null;
        return ResourceRecommendationModel.newInstance(<ResourceRecommendationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationModel) {
        if (!obj) return;

        models.ResourceRecommendationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationModel): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * unique identifier for resource recommendation
     */
    resource_recommendation_id: string;

    /**
     *  Resource identifier id of resource recommendation
     */
    resource_id: string;

    /**
     * Resource identifier name of resource recommendation
     */
    resource_name: string;

    /**
     * Type of resource
     */
    resource_type: string;

    /**
     * resource group location
     */
    resourcegroup_location: string;

    /**
     * Status of resource recommendation
     */
    status: string;

}
